module.exports = __webpack_public_path__ + "static/media/10-1.4a9471ae.png";